import React from 'react';
import PropTypes from 'prop-types';
import get from 'lodash/get';
import { useLocation, useHistory, useParams } from 'react-router-dom';

// Containers
import FamilyFreightSimulateForm from 'containers/families/FamilyFreightSimulateForm';
import LandingProductBestPaymentMethod from 'containers/landing/LandingProductBestPaymentMethod/Loadable';
import FamilyProductBestPaymentMethod from 'containers/families/FamilyProductBestPaymentMethod/Loadable';
import SellerPolicyWidget from 'containers/widgets/SellerPolicyWidget/Loadable';

// Components
import { Product } from 'components/common';

// Hooks
import { useBasket } from 'hooks';

function MainProduct(props) {
  const { enrollment, content, product, variant, onCheckout, onEnrollmentClear } = props;

  // Hooks
  const history = useHistory();
  const { pathname, search } = useLocation();
  const { landingPageSlug } = useParams();

  // Constants
  const enrollmentSlug = get(enrollment, 'slug');
  const enrollmentUid = get(enrollment, 'uid');
  const { slug: productSlug, uid: productUid, seller } = product;
  const { slug: variantSlug, uid: variantUid } = variant || {};

  // Custom hooks
  const { basket, handling, alerting, onAdd, onRemove, onBuy, onAlert } = useBasket({
    productSlug: variantSlug || productSlug,
    productUid: variantUid || productUid,
    enrollmentUid,
    enrollmentSlug,
  });

  const viewSettings = {
    disableHeader: content.disableHeader,
    disableBuyBox: content.disableBuyBox,
    disableInformation: content.disableInformation,
    disableDescription: content.disableDescription,
    disableReview: content.disableReview,
    onEnrollmentClear,
  };

  const callback = () => {
    if (enrollment) {
      history.push('/checkout');
    } else {
      onCheckout();
    }
  };

  const onSelect = newProduct => history.push(`?o=${newProduct?.slug || ''}`);

  return (
    <Product.View
      disableGutters
      disableReview
      shareUrl={[window?.origin, pathname, search].join('')}
      product={{ ...product, basket }}
      selected={variant && { ...variant, basket }}
      loading={handling || alerting}
      onSelect={onSelect}
      onCheckout={callback}
      onBuy={(item, additional) => onBuy(item, additional, callback)}
      onAdd={onAdd}
      onRemove={onRemove}
      onAlert={onAlert}
      to={newProduct => ({
        pathname: ['/l', landingPageSlug, 'p', newProduct?.slug].join('/'),
        state: { enrollment },
      })}
      enrollment={enrollment}
      FamilyFreightSimulateForm={
        enrollment && (
          <FamilyFreightSimulateForm
            enrollmentSlug={enrollmentSlug}
            productSlug={variantSlug || productSlug}
          />
        )
      }
      FamilyProductBestPaymentMethod={
        enrollment ? (
          <FamilyProductBestPaymentMethod
            enrollmentSlug={enrollmentSlug}
            productSlug={variantSlug || productSlug}
          />
        ) : (
          <LandingProductBestPaymentMethod productSlug={variantSlug || productSlug} />
        )
      }
      SellerPolicyWidget={<SellerPolicyWidget seller={seller} />}
      {...viewSettings}
    />
  );
}

MainProduct.propTypes = {
  enrollment: PropTypes.object,
  content: PropTypes.object,
  product: PropTypes.object,
  variant: PropTypes.object,
  onCheckout: PropTypes.func,
  onEnrollmentClear: PropTypes.func,
};

export default MainProduct;
